import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { GenericFormFields } from '../../data-access/models/interface/generic-form.interface';
@Component({
  selector: 'idp-generic-form',
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.scss']
})
export class GenericFormComponent implements AfterViewInit {
  @Input() genericFormFields: GenericFormFields = {} as GenericFormFields;
  @ViewChild('genericRedirectForm')
  genericRedirectForm!: ElementRef<HTMLFormElement>;

  ngAfterViewInit(): void {
    this.genericRedirectForm?.nativeElement.submit();
  }
}
